// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"ResultDeal_iconSync__1w0vs","fa-spin":"ResultDeal_fa-spin__21hLI","iconInfo":"ResultDeal_iconInfo__1i0gO"};